const verificationPath = 'verification';

export default {
  verificationGetStatus: [verificationPath, 'get-ajax-status'].join('/'),
  verificationRequest: [verificationPath, 'ajax-verify-request'].join('/'),
  personalizedSeats: 'get-ajax-seats',
  goToCart: 'ajax-go-to-cart',
};
